<script setup lang="ts"></script>
<template>
  <div class="loading-spinner">
    <span class="loading-spinner__loader"></span>
  </div>
</template>

<style lang="scss" scoped>
  .loading-spinner {
    display: flex;
    justify-content: center;
    align-items: center;

    &__loader {
      margin-top: 25%;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: inline-block;
      position: relative;
      background: linear-gradient(0deg, rgba(247, 148, 29, 0.2) 33%, rgb(247, 148, 29) 100%);
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
    }
    &__loader::after {
      content: '';
      box-sizing: border-box;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: #fff;
    }
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
